import { getUser, getToken } from './service/AuthService';
import { getUserGoal } from './service/GoalService';

import ProblematicLogEntry from './ProblematicLogEntry';

import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Profile.css';


const logFetchUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/problematiclogfetch';

const Profile = () => {
    const user = getUser();
    const username = user !== 'undefined' && user ? user.username: '';

    const skills = [
    { name: 'JavaScript', level: 30 },
    { name: 'React', level: 6 },
    { name: 'Angular', level: 206 },
    { name: 'HTML', level: 6 },
    { name: 'CSS', level: 3 },
    ];

    const totalExperience = 3320;
    const skillPoints = 332;
    const level = 4;
    const nextLevelExperience = 1000;

    const renderSkillBar = (skill) => {
    const barWidth = `${(skill.level / skillPoints) * 100}%`;
    return (
        <div className="skill-bar">
        <span className="skill-name">{skill.name}</span>
        <div className="progress-bar">
            <div className="progress" style={{ width: barWidth }}></div>
        </div>
        <span className="skill-level">{skill.level}</span>
        </div>
    );
    };

    return (
        <div className="wrapper" style={{ marginTop: '6.5rem', marginLeft: '1rem', marginRight: '1rem'}}>
            <div className="profile-card">
                <div className="header">
                <div className="avatar">A</div>
                <div className="info">
                    <h2>{username}</h2>
                    <p>Level {level} </p>
                </div>
                </div>
                <div className="progress-container">
                <div className="experience-bar">
                    <div className="progress" style={{ width: `${(totalExperience / nextLevelExperience) * 100}%` }}></div>
                </div>
                <div className="experience-info">
                    <span>Experience: {totalExperience}</span>
                    <span>Next Level: {nextLevelExperience}</span>
                </div>
                </div>
                <div className="skill-points">Skill Points: {skillPoints}</div>
                <div className="skills">
                {skills.map(renderSkillBar)}
                </div>
            </div>
        </div>
    );
};

export default Profile;